import React, { useState } from 'react';
import '../../animation/anima.css'

const Introtoggle = () => {
  const [selectedButton, setSelectedButton] = useState('Our Work'); 

  return (
    <div className="bg-sec1 py-10 pb-32">
      <div className="text-prime text-2xl font-semibold font-[Montserrat] flex items-center justify-center pt-20">
        Let’s build better
      </div>
      <div className="text-5xl font-bold font-[Montserrat] flex items-center justify-center mt-6">
        How we work ?
      </div>
      <div className="bg-prime flex justify-center items-center mx-[620px] mt-10 rounded-lg h-32 py-10">
        {['Our Work', 'Our Values', 'Our Approach'].map((text, index) => (
          <button
            key={index}
            className={`about-button mx-5 text-white text-xl font-bold font-prime font-xl p-6 ${selectedButton === text ? (text === 'Our Work' ? 'initial-effect' : '') : ''}`}
            onClick={() => setSelectedButton(text)}
          >
            {text}
            </button>
        ))}
      </div>
          {
              selectedButton === 'Our Work' && <div className='flex flex-col mx-[650px]'>
                  <div className="font-prime text-2xl text-center font-bold mt-10">
                      Empowering businesses with lovable software products
                  </div>
                  <ul className="mt-8"> 
                    <li className="disc-circle my-5 font-prime font-lg text-xl">We're driven by the mission to build lovable software products (not projects) that simplify the customer experience and help businesses to do more.</li>
                    <li className="disc-circle my-5 font-prime font-lg text-xl">We tend to work in verticals that we know better – streaming media (audio/video) and digital commerce.</li>
                    <li className="disc-circle my-5 font-prime font-lg text-xl">We're inspired by JTBD (Job to be done) framework. Simply put, we'd love to bring elements of why to our software products and not just what.</li>
                    <li className="disc-circle my-5 font-prime font-lg text-xl">We only win when you (our client) win.</li>
                  </ul>
              </div>
          }
          {
              selectedButton === 'Our Values' && <div className='flex flex-col mx-[650px]'>
                  <div className="font-prime text-2xl text-center font-bold mt-10">
                      7 things that help us put our 'Raft' back in the right direction.
                  </div>
                  <div className="">
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-14 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-lg">1</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We believe in trying new ways of doing and failing rather than not doing. We strive to simplify.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-8 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-lg">2</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We believe that one good thing is better than everything.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-[3.3rem] h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-xl">3</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We try every day to learn. We learn from everyone. Peers, customers, partners, and leaders.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-8 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-xl">4</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We try to be open and unassuming so that we can grow.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-8 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-xl">5</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We believe in owning the outcomes and not just tasks.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-[2.1rem] h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-xl">6</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We run for each other. Our peers, customers, and partners.
                      </div>
                      </div>
                      <div className="flex flex-row mt-8">
                          <div className="bg-prime rounded-full w-8 h-8 flex justify-center">
                                <div className="text-white font-bold text-xl">7</div>
                            </div>
                          <div className=" font-prime font-lg text-xl flex flex-row ml-5">
                            We enjoy what we do. :)
                      </div>
                      </div>
                  </div>
              </div>
          }
          {
              selectedButton === 'Our Approach' && <div className='flex flex-col mx-[650px]'>
                  <div className="font-prime text-2xl text-center font-bold mt-10">
                      We're a startup-turned product development agency. So our approach is a 'little' different than a standard development agency.
                  </div>
                  <div className="">
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-24 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-lg">1</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We don't take just requirements from you and deploy team. We understand the problem you're trying to solve. We design solutions that add value and not features.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-12 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-lg">2</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We don't re-invent the wheel. We do what it takes so that you can go to market faster.
                      </div>
                      </div>
                      <div className="flex flex-row items-center justify-center">
                          <div className="bg-prime rounded-full w-12 h-8 flex items-center justify-center">
                                <div className="text-white font-bold text-xl">3</div>
                            </div>
                          <div className="my-5 font-prime font-lg text-xl flex flex-row ml-5 mt-8">
                          We keep things simple and prudent. We avoid unnecessary tech complexities.
                      </div>
                      </div>
                      <div className="flex flex-row mt-8">
                          <div className="bg-prime rounded-full w-8 h-8 flex justify-center">
                                <div className="text-white font-bold text-xl">4</div>
                            </div>
                          <div className="font-prime font-lg text-xl flex flex-row ml-5">
                          We only win when you (our client) win.
                      </div>
                      </div>
                  </div>
              </div>
          }
    </div>
  );
};

export default Introtoggle;
